export function getTimeUntilSessionExpiryMs(identity) {
    if (!("getDelegation" in identity)) {
        return 0;
    }
    const expiryDateTimestampMs = Number(identity
        .getDelegation()
        .delegations.map((d) => d.delegation.expiration)
        .reduce((current, next) => (next < current ? next : current)) / BigInt(1_000_000));
    return expiryDateTimestampMs - Date.now();
}
